export const iconFontAwesomeMedicalHealthVials = (
	<i className="fa-solid fa-vials"></i>
);
